export default __webpack_public_path__ + "static/media/ps.f88d6b6e.png";